import React from 'react';
import { Link } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import * as yup from "yup";
import { TextInput } from '../FormInputs';
// @ts-ignore
import Logo from '../../assets/logo.png';
import { LoginInput } from '../../types';

type Props = {
  onSubmit: (values: LoginInput) => Promise<any>;
  loading: boolean;
  error?: boolean;
};

const Schema = yup.object({
  username: yup.string().trim().required('Requerido'),
  password: yup.string().trim().required('Requerido'),
});

export default function Form({ onSubmit, loading, error }: Props) {
  const form = useForm({
    resolver: yupResolver(Schema),
    defaultValues: {
      username: '',
      password: '',
    }
  });

  return (
    <Box>
      <Box border="1px solid" borderColor="primary.main" borderRadius={2} px={2} sx={{ pt: { xs: 2, md: 10 }, pb: { xs: 2, md: 6 } }}>
        <Box textAlign="center">
          <img src={Logo} alt="logo" style={{ maxWidth: '100px' }} />
        </Box>
        <Box py={1} mb={6} px={2}>
          <Typography align="center" fontSize="1.1rem">
            Tu Dashboard
          </Typography>
          <Typography align="center" fontSize="1.1rem">
            Acá esta la data. Ingresá con tu <br />usuario y contraseña.
          </Typography>
        </Box>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} noValidate autoComplete="off">
            <Box px={2}>
              <TextInput
                name="username"
                label="Usuario"
                required
                disabled={loading}
              />
              <TextInput
                name="password"
                label="Contraseña"
                type="password"
                required
                disabled={loading}
              />
              {
                error && (
                  <Alert severity="error" elevation={3}>
                    Usuario y/o contraseña incorrectos
                  </Alert>
                )
              }
            </Box>
            <Box px={2} pb={2}>
              <Typography href="https://auntap.atlassian.net/servicedesk/customer/portal/3" target="_blank" component="a" variant="body2" align="left">
                Olvidé mi contraseña
              </Typography>
            </Box>
            <Box p={2} textAlign="center">
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={loading}
                fullWidth
                style={{ color: 'black', fontWeight: 'bold', fontSize: '1rem' }}
              >
                {loading ? <CircularProgress size={20} /> : 'Enter the Tapi world'}
              </Button>
            </Box>
          </form>
        </FormProvider>
      </Box>
    </Box>
  );
}